@file:OptIn(InternalResourceApi::class)

package helpmycity.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.PluralStringResource
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/helpmycity.shared.generated.resources/"

@delegate:ResourceContentHash(-624_792_979)
internal val Res.plurals.admin_users_count: PluralStringResource by lazy {
      PluralStringResource("plurals:admin_users_count", "admin_users_count", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 69),
      ))
    }

@delegate:ResourceContentHash(1_573_009_510)
internal val Res.plurals.detail_edited_times: PluralStringResource by lazy {
      PluralStringResource("plurals:detail_edited_times", "detail_edited_times", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 84, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80, 91),
      ))
    }

@delegate:ResourceContentHash(-1_005_034_829)
internal val Res.plurals.detail_support_count: PluralStringResource by lazy {
      PluralStringResource("plurals:detail_support_count", "detail_support_count", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 188, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172, 128),
      ))
    }

@delegate:ResourceContentHash(-486_313_957)
internal val Res.plurals.duplicate_warning: PluralStringResource by lazy {
      PluralStringResource("plurals:duplicate_warning", "duplicate_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 321, 209),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 301, 229),
      ))
    }

@delegate:ResourceContentHash(-950_938_205)
internal val Res.plurals.issues_count: PluralStringResource by lazy {
      PluralStringResource("plurals:issues_count", "issues_count", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 531, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 531, 64),
      ))
    }

@delegate:ResourceContentHash(233_451_696)
internal val Res.plurals.map_located_count: PluralStringResource by lazy {
      PluralStringResource("plurals:map_located_count", "map_located_count", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 779, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 763, 133),
      ))
    }

@delegate:ResourceContentHash(82_924_967)
internal val Res.plurals.map_located_count_filtered: PluralStringResource by lazy {
      PluralStringResource("plurals:map_located_count_filtered", "map_located_count_filtered", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 600, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 596, 166),
      ))
    }

@delegate:ResourceContentHash(-1_830_458_707)
internal val Res.plurals.sync_pending: PluralStringResource by lazy {
      PluralStringResource("plurals:sync_pending", "sync_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 925, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 897, 108),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainPlurals0Resources(map: MutableMap<String, PluralStringResource>) {
  map.put("admin_users_count", Res.plurals.admin_users_count)
  map.put("detail_edited_times", Res.plurals.detail_edited_times)
  map.put("detail_support_count", Res.plurals.detail_support_count)
  map.put("duplicate_warning", Res.plurals.duplicate_warning)
  map.put("issues_count", Res.plurals.issues_count)
  map.put("map_located_count", Res.plurals.map_located_count)
  map.put("map_located_count_filtered", Res.plurals.map_located_count_filtered)
  map.put("sync_pending", Res.plurals.sync_pending)
}
